import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import {SchemaFieldSelector, SchemaFieldSelectorOption} from 'schemas/SchemaFieldSelectorConstants';

/**
 * Return the options from the schemaFieldSelector that correspond to the specified ids.
 */
export function getSelectorOptions(
  schemaFieldSelectorOptionIds: Array<string>,
  schemaFieldSelector: SchemaFieldSelector
): Array<SchemaFieldSelectorOption> {
  const options = [];
  for (const optionId of schemaFieldSelectorOptionIds) {
    const option = _.findWhere(schemaFieldSelector.schemaFieldSelectorOptions, {
      id: optionId,
    });
    if (option) {
      options.push(option);
    } else {
      assertAndContinue(false, 'Option was not found in selector', {
        optionId,
        schemaFieldSelector,
      });
    }
  }
  return options;
}

/**
 * Return whether all the option ids are present in the selector.
 */
export function areAllOptionsValid(
  schemaFieldSelectorOptionIds: Array<string>,
  schemaFieldSelector: SchemaFieldSelector
): boolean {
  for (const optionId of schemaFieldSelectorOptionIds) {
    const option = _.findWhere(schemaFieldSelector.schemaFieldSelectorOptions, {
      id: optionId,
    });
    if (!option) {
      return false;
    }
  }
  return true;
}
